import { ListMain } from './components/containers/ListMain';

export const CourierInvoicesList = () => <ListMain />;
